import React, { Component, useEffect, useState, } from 'react';
import { CSSTransition } from './CSSTransition';
import phaseEngine from '../util/PhaseEngine';

class LayoutGroup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			css: props.CSSModules[props.condor_render_name],
			unmountSetting: true, // Always start true to prevent flash; componentDidMount switches to false after delay
		};

		this.groupRef = React.createRef();
	}

	componentDidMount() {
		this._unregisterPhaseEngine = phaseEngine.register(
			`layoutGrp${this.props.component_name}`,
			{
				phases: this.props.show_on_phase || [],
				ref: this.groupRef,
				type: 'content',
			}
		);

		// RTG doesn't apply CSS classes for initial EXITED state (in=false, unmountOnExit=false).
		// Manually apply exit-done class so hidden groups start with opacity: 0.
		if (!this.displayCondition() && !this.state.unmountSetting && this.groupRef.current) {
			this.groupRef.current.classList.add('contentFade-exit-done');
		}

		// prevents all components showing on load
		let unmountSetting = this.props.unmount_group;
		if (!this.props.unmount_group && (unmountSetting !== undefined && unmountSetting !== null && unmountSetting !== '')) {
			console.log(`Changing ${this.props.custom_tlc_builder_name} from ${unmountSetting} to false`);
			setTimeout(() => {
				this.setState({
					unmountSetting: false
				}, () => {
					// Also apply after unmountSetting switches to false
					if (!this.displayCondition() && this.groupRef.current) {
						this.groupRef.current.classList.add('contentFade-exit-done');
					}
				});
			}, 2000);
		}
	}

	componentWillUnmount() {
		if (this._unregisterPhaseEngine) this._unregisterPhaseEngine();
	}

	displayCondition() {
		if (
			(Array.isArray(this.props.show_on_phase) && this.props.show_on_phase.length === 0) ||
			this.props.show_on_phase === undefined ||
			this.props.show_on_phase === null ||
			(this.props.show_on_phase && this.props.show_on_phase.includes(this.props.navProps.animationPhase))
		) {
			return true;
		}
		return false;
	}

	effectiveShowPhase() {
		if (this.props.showPhase === false) {
			return false;
		}
		return this.displayCondition();
	}

	// Layout classes - CSS Modules
	makeClasses(classArray) {
		let css = this.state.css;
		let classes = '';
		if (Array.isArray(classArray) && classArray.length > 0) {
			classArray.forEach((element) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(element)) {
					classes += `${css[element]} `;
				}
			});
		}
		return classes;
	}

	fadeOnMenu(menuActive) {
		let classes = '';
		if (menuActive === true && this.displayCondition() === true) {
			classes = 'mainMenuOpen'
		}
		return classes;
	}

	adaAction(adaActive) {
		let classes = '';
		if (adaActive === true && this.displayCondition() === true) {
			classes = 'adaActive'
		}
		return classes;
	}

	testId() {
		if (Array.isArray(this.props.condor_layout_classes) && this.props.condor_layout_classes.includes('branding')) {
			return 'layoutGrpBranding';
		}
		return undefined;
	}

	expandComponentList() {
		// Inject showPhase prop into child components for animation phase control
		// Child components like Brood.js use showPhase to control play/stop behavior
		const showPhase = this.effectiveShowPhase();

		return React.Children.map(this.props.condor_component_list, (child) => {
			if (React.isValidElement(child)) {
				return React.cloneElement(child, { showPhase });
			}
			return child;
		});
	}

	render() {
		let css = this.state.css;

		// Custom classes
		let customGlobalClasses = '';
		if (this.props.custom_classes && this.props.custom_classes.length > 0) {
			this.props.custom_classes.forEach((element) => {
				if ((/^([a-z_]|-[a-z_-])[a-z\d_-]*$/i).test(element)) {
					customGlobalClasses += ` ${element}`;
				}
			});
		}

		const showCondition = this.displayCondition();

		return (
			<CSSTransition
				in={showCondition}
				appear={showCondition}
				timeout={820}
				unmountOnExit={this.state.unmountSetting}
				classNames='contentFade'
				nodeRef={this.groupRef}>
					<div ref={this.groupRef} id={`layoutGrp${this.props.component_name}`} className={`${customGlobalClasses} ${this.fadeOnMenu(this.props.navProps.showMenu)} ${this.adaAction(this.props.navProps.adaActive)} ${this.makeClasses(this.props.condor_layout_classes)} ${css[this.props.theme_variation]}`} data-test-id={this.testId()}>
						{this.expandComponentList()}
					</div>
			</CSSTransition>
		);

	}

};

export default LayoutGroup;